import React from 'react'
import supabase  from '../config/supabaseClient';
// import {useNavigate} from 'react-router-dom';


function LogOut() {


// async function signOut() of supabase.auth.signOut()
const signOut = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) console.log('Error logging out:', error.message);
    //navigate back to the landing page
    window.location.reload()
};




    
  return (
    <div>
            <button className='MainBTN' onClick={signOut}>Sign Out</button>

    </div>
  )
}

export default LogOut